import { A } from "@solidjs/router";
import { Show, type JSX } from "solid-js";
import { Credit } from "./Credit.tsx";
import { ImportProvider, useImporter } from "./createFileImporter.tsx";
import { DropTarget } from "./DropTarget.tsx";
import { FilesIcon, SettingsIcon } from "./Icons.tsx";

export function AppShell(props: { children: JSX.Element }): JSX.Element {
  return (
    <ImportProvider>
      <Shell>{props.children}</Shell>
    </ImportProvider>
  );
}

function Shell(props: { children: JSX.Element }): JSX.Element {
  const importer = useImporter();

  return (
    <DropTarget
      label="ここに落とすと開きます"
      hint="動画・画像・音声。ファイルはこの端末から出ません"
      onFiles={(files) => void importer.open(files)}
    >
      <div class="mk-shell">
        <nav class="mk-shell__nav" aria-label="メイン">
          <div class="mk-shell__brand">
            <img src="/icon.svg" alt="" width="26" height="26" />
            <span>mediaknife</span>
          </div>
          <A class="mk-shell__link" href="/" end>
            <FilesIcon />
            <span class="mk-shell__label">ファイル</span>
          </A>
          <A class="mk-shell__link" href="/settings">
            <SettingsIcon />
            <span class="mk-shell__label">設定</span>
          </A>
          <Credit />
        </nav>
        <main class="mk-shell__main">{props.children}</main>
      </div>

      <Show when={importer.busy()}>
        <div class="mk-busy" role="status">
          <span class="mk-busy__spinner" aria-hidden="true" />
          <span>{importer.status() ?? "開いています"}</span>
        </div>
      </Show>
    </DropTarget>
  );
}
